import { Action } from '@anm/components/ActionsDropdown';
import DuplicateAction from '@anm/components/dropdown-actions/duplicate/DuplicateAction';
import { getDropdownAction } from '@anm/helpers/dropdownActions';
import { useSelector } from 'react-redux';

import { userSelectors } from '../../../../store/modules/user';
import { isUserFree } from '../../../../store/modules/user/selectors';

const useDuplicateAction = (handler?: () => void) => {
  const userProfile = useSelector(userSelectors.selectUserProfile);
  const shouldUpgrade = isUserFree(userProfile);

  const action = getDropdownAction('onDuplicate');

  const duplicateAction: Action = {
    icon: action.icon,
    disabled: shouldUpgrade,
    autoClose: !shouldUpgrade,
    renderComponent: () => (
      <DuplicateAction {...{ action, handler, shouldUpgrade }} />
    )
  };

  return duplicateAction;
};

export default useDuplicateAction;
